import { jsx } from "react/jsx-runtime";
import { EditorTableCellElement } from "@contember/ui";
function TableCellElementRenderer(props) {
  return /* @__PURE__ */ jsx(
    EditorTableCellElement,
    {
      attributes: props.attributes,
      justify: props.element.justify,
      headerScope: props.element.headerScope,
      children: props.children
    }
  );
}
export {
  TableCellElementRenderer
};
//# sourceMappingURL=TableCellElementRenderer.js.map
